import React, { useState, useEffect, useRef } from "react";
import "./Navbar.css";
import harmon from "../../assets/harmonlogoproperty.jpeg";
import {

  FiMenu,
  FiX,
  FiChevronDown,
} from "react-icons/fi";

/* ---------------- NAV ITEMS ---------------- */
const NAV_ITEMS = [
  { label: "Home", href: "/", hasDropdown: false },
  {
    label: "Spaces",
    href: "#", // route removed; acts as a toggle only
    hasDropdown: true,
    items: [
      { label: "Lofts", href: "/spaces/lofts" },
      { label: "Commercial", href: "/spaces/commercial" },

    ],
  },
  { label: "Commercial Tenants", href: "/commercial-tenants", hasDropdown: false },
  { label: "Contact", href: "/contact", hasDropdown: false },
];

export default function Navbar() {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeDropdown, setActiveDropdown] = useState(null); // label or null

  const drawerRef = useRef(null);
  const navRef = useRef(null);

  /* ---------- scroll shadow ---------- */
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 4);
    onScroll();
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  /* ---------- click-away for drawer ---------- */
  useEffect(() => {
    const onClickAway = (e) => {
      if (
        drawerRef.current &&
        !drawerRef.current.contains(e.target) &&
        !e.target.closest(".tn-hamburger")
      ) {
        setMobileOpen(false);
      }
    };
    if (mobileOpen) document.addEventListener("mousedown", onClickAway);
    return () => document.removeEventListener("mousedown", onClickAway);
  }, [mobileOpen]);

  /* ---------- dropdown toggle ---------- */
  const toggleDropdown = (label) => {
    setActiveDropdown((prev) => (prev === label ? null : label));
  };

  /* ---------- close dropdown on ESC (accessibility) ---------- */
  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setActiveDropdown(null);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  return (
    <header
      className={`tn-header ${scrolled ? "tn-header--scrolled" : ""}`}
      ref={navRef}
    >
      {/* Top info bar */}
      <div className="tn-topbar">
        <div className="tn-container tn-topbar__row">
          <div className="tn-topbar__left">
            <span className="tn-call-label">Call Us:</span>
            <a className="tn-call" href="tel:+  253-627-2663">
             253-627-2663
            </a>
          </div>
        </div>
      </div>

      {/* Main nav */}
      <nav className="tn-mainnav" role="navigation" aria-label="Main">
        <div className="tn-container tn-mainnav__row">
          <a className="tn-brand" href="/">
            <img
              src={harmon}
              alt="harmon property"
            />
          </a>

          <button
            className="tn-hamburger"
            aria-label="Open menu"
            aria-expanded={mobileOpen}
            onClick={() => setMobileOpen(true)}
          >
            <FiMenu />
          </button>

          {/* Desktop menu */}
          <ul className="tn-menu">
            {NAV_ITEMS.map((item) => {
              const isOpen = activeDropdown === item.label;
              return (
                <li
                  key={item.label}
                  className={`tn-menu__item ${item.hasDropdown ? "has-dropdown" : ""
                    }`}
                  onMouseEnter={() =>
                    item.hasDropdown && setActiveDropdown(item.label)
                  }
                  onMouseLeave={() =>
                    item.hasDropdown && setActiveDropdown(null)
                  }
                >
                  <a
                    className="tn-menu__link"
                    href={item.href}
                    aria-haspopup={item.hasDropdown ? "true" : undefined}
                    aria-expanded={
                      item.hasDropdown ? (isOpen ? "true" : "false") : undefined
                    }
                    onClick={(e) => {
                      if (item.hasDropdown) {
                        // prevent navigation; act as a toggle button
                        e.preventDefault();
                        toggleDropdown(item.label);
                      }
                    }}
                  >
                    {item.label}
                    {item.hasDropdown && <FiChevronDown className="tn-caret" />}
                  </a>

                  {item.hasDropdown && isOpen && (
                    <div
                      className="tn-dropdown"
                      role="menu"
                      aria-label={`${item.label} submenu`}
                    >
                      <div className="tn-dropdown__inner">
                        {item.items?.map((sub) => (
                          <a
                            key={sub.label}
                            href={sub.href}
                            className="tn-dropdown__link"
                            role="menuitem"
                          >
                            {sub.label}
                          </a>
                        ))}
                      </div>
                    </div>
                  )}
                </li>
              );
            })}
          </ul>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div className={`tn-drawer ${mobileOpen ? "is-open" : ""}`}>
        <div
          className="tn-drawer__overlay"
          onClick={() => setMobileOpen(false)}
        />
        <div className="tn-drawer__panel" ref={drawerRef}>
          <div className="tn-drawer__head">
            <a
              className="tn-brand tn-brand--drawer"
              href="/"
              onClick={() => setMobileOpen(false)}
            >
              <img
                src={harmon}
                alt="harmon property"
              />
            </a>
            <button
              className="tn-drawer__close"
              aria-label="Close menu"
              onClick={() => setMobileOpen(false)}
            >
              <FiX />
            </button>
          </div>

          <div className="tn-drawer__body">
            <div className="tn-drawer__cta">{/* optional CTA */}</div>

            <ul className="tn-drawer__menu">
              {NAV_ITEMS.map((item) => {
                const isOpen = activeDropdown === item.label;
                return (
                  <li key={item.label}>
                    <a
                      href={item.href}
                      onClick={(e) => {
                        if (item.hasDropdown) {
                          e.preventDefault();
                          toggleDropdown(item.label);
                        } else {
                          setMobileOpen(false);
                        }
                      }}
                      className={
                        item.hasDropdown
                          ? isOpen
                            ? "has-dropdown active"
                            : "has-dropdown"
                          : ""
                      }
                    >
                      {item.label}{" "}
                      {item.hasDropdown && (
                        <FiChevronDown className="tn-caret" />
                      )}
                    </a>

                    {item.hasDropdown && isOpen && (
                      <ul className="tn-submenu">
                        {item.items?.map((sub) => (
                          <li key={sub.label}>
                            <a
                              href={sub.href}
                              onClick={() => setMobileOpen(false)}
                            >
                              {sub.label}
                            </a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                );
              })}
            </ul>

            {/* optional social/footer can go here */}

          </div>
        </div>
      </div>
    </header>
  );
}
